import { render } from "./EditView.vue?vue&type=template&id=27424a3f"
import script from "./EditView.vue?vue&type=script&lang=js"
export * from "./EditView.vue?vue&type=script&lang=js"

import "./EditView.vue?vue&type=style&index=0&id=27424a3f&lang=scss"

import exportComponent from "C:\\Users\\astac\\OneDrive\\Рабочий стол\\twodolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__